import script from "./ListingSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingSlider.vue?vue&type=script&setup=true&lang=js"

import "./ListingSlider.vue?vue&type=style&index=0&id=bc9d3b70&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc9d3b70"]])

export default __exports__